import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function Customer() {
  const { t } = useTranslation();
  const location = useLocation();

  // زبان از سگمنت اول URL
  const seg = location.pathname.split("/")[1];
  const lang = seg === "fa" || seg === "en" ? seg : "en";

  // اگر خواستی داخل پوشه‌ی جدا بذاری، بنویس: 'clients/client1.png'
  const logos = useMemo(
    () => [
      "client1.png",
      "client2.png",
      "client3.png",
      "client4.png",
      "client5.png",
      "client6.png",
      "client7.png",
      "client8.png",
      "client9.png",
      "client10.png",
    ],
    []
  );

  // برای اسکرول بی‌نهایت، آرایه را دو برابر می‌کنیم
  const allLogos = useMemo(() => [...logos, ...logos], [logos]);

  const srcOf = (file) => (file.startsWith("/") ? file : `/assets/${file}`);
  const altOf = (i) =>
    t("customer.clientAlt", { index: (i % logos.length) + 1 });

  return (
    <section
      className="col-xs-12 pt-5 pb-5 pl-0 pr-0 costumer"
      dir={lang === "en" ? "ltr" : "rtl"}
      aria-label={t("customer.sectionLabel")}
    >
      <h2 className="text-blue1">{t("customer.title")}</h2>

      <div className="carousel-container pb-2" role="list" aria-live="polite">
        <div className="carousel-track">
          {allLogos.map((logo, i) => (
            <div className="carousel-item" key={`${logo}-${i}`} role="listitem">
              <img src={srcOf(logo)} alt={altOf(i)} loading="lazy" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
